// Modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Components
import { ErrorDisplayComponent } from "../error-display/error-display.component";
import { PaginationComponent } from '../pagination/pagination.component';
import { UploadFileComponent } from '../upload-file/upload-file.component';
import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminSidebarComponent } from './sidebar/sidebar.component';
import { AdminTopbarComponent } from './topbar/topbar.component';
import { AdminAccountComponent } from './account/account.component';
import { AdminAccountCreateComponent } from './account/create/account-create.component';
import { AdminAccountListComponent } from './account/list/account-list.component';
import { AdminAccountEditComponent } from './account/edit/account-edit.component';
import { AdminSettingComponent } from './setting/setting.component';
import { AdminSettingEmailComponent } from './setting/email/email.component';
import { ReportingComponent } from './reporting/reporting.component';

// Others
import { PipeModule } from '../../shared/pipe.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {
  MatDatepickerModule,
  MatNativeDateModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatRippleModule
} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    PipeModule,
    MultiSelectModule,
    CalendarModule,
    ChipsModule,
    DialogModule,
    ProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule, 
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule
  ],
  declarations: [
    AdminComponent,
    ErrorDisplayComponent,
    UploadFileComponent,
    PaginationComponent,
    AdminSidebarComponent,
    AdminTopbarComponent,
    AdminAccountComponent,
    AdminAccountCreateComponent,
    AdminAccountEditComponent,
    AdminAccountListComponent,
    AdminSettingComponent,
    AdminSettingEmailComponent,
    ReportingComponent
  ],
  exports: [
    ErrorDisplayComponent,
    PipeModule,
  ],
  providers: [

  ]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin.module.ts